<template>
  <a-modal
    ref="model"
    centered
    title="添加房型图片"
    v-model="visible"
    width="850px"
    cancelText="关闭"
    @cancel="onCancel"
    @ok="onOk"
    :maskClosable="false"
    :destroyOnClose="true"
  >
    <div class="pic-content">
      <div>
        <label>房型：</label> <strong>{{ roomInfo.Name }}</strong>
      </div>
      <div>
        <label style="width: 80px;"> 图片：</label>
        <div style="width: 750px;">
          <a-upload
            :action="actionUrl"
            list-type="picture-card"
            :file-list="fileList"
            :headers="header"
            :multiple="true"
            :data="{ dataId: roomInfo.Id }"
            @preview="handlePreview"
            @change="handleChange"
            :remove="removePic"
            accept=".png, .jpg, .jpeg"
          >
            <div>
              <a-icon type="plus" />
              <div class="ant-upload-text">
                添加图片
              </div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="房型图片" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
import urls from "@/api/url";
// import clone from "lodash/clone";
import configs from "@/config/baseConfig";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: "AddRoomPic",
  components: {},
  data() {
    return {
      id: 0,
      header: "",
      visible: false,
      roomInfo: {},
      previewVisible: false,
      previewImage: "",
      fileList: [
        // {
        //   uid: "-1",
        //   name: "image.png",
        //   status: "done",
        //   url:
        //     "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
        // }
      ]
    };
  },
  created() {
    const user = cache.get("user");
    if (user) {
      const token = user.Token;
      if (token) {
        this.actionUrl = this.$config.serverUrl + urls["PicSave"];
        this.header = {
          Authorization: token
        };
      }
    }
  },
  mounted() {},
  methods: {
    show(row) {
      this.roomInfo = row;
      this.visible = true;
      this.fileList = [];
      this.getPicList();
    },
    getPicList() {
      this.$post("GetPicPath", { Id: this.roomInfo.Id }).then(res => {
        if (res.Data && res.Data.length) {
          res.Data.forEach(el => {
            this.fileList.push({
              uid: el.Id,
              name: el.Name,
              status: "done",
              url: configs.serverUrl + "/" + el.Value,
              response: {
                Data: {
                  AppointId: el.Id
                }
              }
            });
          });
        }
      });
    },
    removePic(e) {
      this.$post("PicDelete", {
        Id: e.response.Data.AppointId
      }).then(res => {
        this.$message.success(res.Message);
      });
    },
    onCancel() {
      this.visible = false;
    },
    onOk() {
      this.visible = false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    }
  }
};
</script>

<style lang="less" scoped>
.pic-content {
  padding: 20px;
  & > div {
    display: flex;
    line-height: 40px;
    label {
      line-height: 40px;
      color: #000;
      margin-right: 5px;
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    strong {
      font-size: 16px;
      color: #333;
    }
  }
  /deep/.ant-upload-list-picture-card {
    float: none;
  }
  /deep/.ant-upload-list-item-info > span {
    height: 100%;
  }
}
</style>
